import { skipToken } from "@reduxjs/toolkit/query";

import { useGetCommentQuery, useGetDiscussionByIdQuery } from "@/redux/service";
import type { ContributionGrade } from "@/redux/certifications/types";
import type { FullCommentResponse } from "@/redux/comments/types";
import { htmlToText } from "@/domains/certifications/utils";
import type { ContributionContext } from "@/features/certifications/community-flags/types";
import { CONTRIBUTION_KINDS } from "@/domains/certifications/constants";

export const useContributionContext = (
  grade: ContributionGrade,
): ContributionContext => {
  const comment = useGetCommentQuery(grade.comment ?? skipToken);
  const commentData = comment.data as FullCommentResponse | undefined;
  const discussionId = grade.discussion ?? commentData?.discussion ?? null;
  const discussion = useGetDiscussionByIdQuery(discussionId ?? skipToken);
  const repliedToQuery = useGetCommentQuery(commentData?.parent ?? skipToken);
  const repliedTo = repliedToQuery.data as FullCommentResponse | undefined;

  const post = discussion.data;
  const isPost = grade.contentKind === CONTRIBUTION_KINDS.POST;
  const own = isPost ? post : commentData;

  return {
    author: own?.createdBy ?? null,
    createdAt: own?.createdAt ?? null,
    discussionId,
    likesCount: own?.likesCount ?? null,
    repliesCount: isPost ? (post?.commentsCount ?? null) : null,
    parentPost:
      !isPost && post
        ? {
            authorName: post.createdBy?.fullName ?? "",
            text: htmlToText(post.content),
          }
        : null,
    repliedTo: repliedTo
      ? {
          authorName: repliedTo.createdBy?.fullName ?? "",
          text: htmlToText(repliedTo.content),
        }
      : null,
  };
};
